export default "__VITE_ASSET__71b67c2e__"